import * as React from 'react';
import { BuiltinBackground } from '../../clipbook/types';

interface NewPageDialogProps {
  visible: boolean;
  cancelable: boolean;
  onSubmitNewPage: (backgroundID: string) => void;
  onCancelNewPage: () => void;
}

export default class NewPageDialog extends React.Component<NewPageDialogProps> {
  private submitBlankPage = () => {
    this.props.onSubmitNewPage(BuiltinBackground.Blank);
  }

  public render() {
    const dialogStyle: React.CSSProperties = {
      visibility: this.props.visible ? 'visible' : 'hidden',
    };

    const headingStyle = {
      margin: '0',
    };

    return (
      <div className="mdc-dialog mdc-dialog--open" style={dialogStyle}>
        <div className="mdc-dialog__surface">
          <header className="mdc-dialog__header">
            <h1 style={headingStyle}>新しいページ</h1>
          </header>
          <section className="mdc-dialog__body">
            まだ白紙しか実装されていません。
          </section>
          <footer className="mdc-dialog__footer">
            <button type="button"
              className="mdc-button mdc-dialog__footer__button"
              onClick={this.submitBlankPage}>
              追加
            </button>
            <button type="button"
              disabled={!this.props.cancelable}
              className="mdc-button mdc-dialog__footer__button"
              onClick={this.props.onCancelNewPage}>
              キャンセル
            </button>
          </footer>
        </div>
        <div className="mdc-dialog__backdrop"></div>
      </div>
    );
  }
}
